import { showAlert } from "../utils/alert";

export default () => ({
  selectedService: null,
  bookingDate: "",
  bookingTime: "",
  customerName: "",
  customerPhone: "",
  isSubmitting: false,

  // Mock data (No futuro, virá da API)
  availableServices: [
    { id: 1, name: "Corte Clássico", price: "R$ 45,00" },
    { id: 2, name: "Barba Terapia", price: "R$ 35,00" },
    { id: 3, name: "Corte + Barba", price: "R$ 70,00" },
    { id: 4, name: "Pezinho / Acabamento", price: "R$ 15,00" },
  ],

  async submitBooking() {
    if (
      !this.selectedService ||
      !this.bookingDate ||
      !this.bookingTime ||
      !this.customerName ||
      !this.customerPhone
    ) {
      showAlert("Por favor, preencha todos os campos obrigatórios.", "warning");
      return;
    }

    this.isSubmitting = true;

    // Mock API delay
    await new Promise((resolve) => setTimeout(resolve, 1000));

    await showAlert(
      `Sucesso! Horário confirmado para ${this.customerName} no dia ${this.bookingDate} às ${this.bookingTime}.`,
      "success",
    );

    // Reset form
    this.selectedService = null;
    this.bookingDate = "";
    this.bookingTime = "";
    this.customerName = "";
    this.customerPhone = "";
    this.isSubmitting = false;
  },
});
